

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InfluencerHeader from './InfluencerHeader';
import Navbar from "./Navbar";
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete'; // Importing MUI Delete icon

const MessageBox = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 7; // Number of users (invitations) per page
  const influencerId = localStorage.getItem("influencerID"); // Getting influencer ID from localStorage
  const navigate = useNavigate(); // Initialize useNavigate

  // Fetching campaigns on component mount
  useEffect(() => {
    const fetchCampaigns = async () => {
      try {
        const response = await fetch('https://server-side-influencer.onrender.com/brand/getUserCampaignsInvites', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            userId: influencerId,  // Passing influencer ID dynamically
          }),
        });

        const data = await response.json();
        if (data.message === "Campaigns found successfully") {
          setCampaigns(data.data);
        }
      } catch (error) {
        console.error("Error fetching campaigns:", error);
      }
    };
    fetchCampaigns();
  }, [influencerId]);

  // Handle remove invitation API calls
  const handleRemoveInvitation = async (campaignId) => {
    try {
      const response = await fetch('https://server-side-influencer.onrender.com/brand/removeInvitation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: influencerId,  // Get influencer ID from localStorage
          campaignId: campaignId, // Get current campaign ID
        }),
      });

      const data = await response.json();

      if (response.status === 200) {
        // Successfully deleted the invitation
        setCampaigns(campaigns.filter((campaign) => campaign._id !== campaignId));
        toast.success("Invitation removed successfully.");
      } else {
        // Handle errors based on the API response
        toast.error(`Failed to remove invitation: ${data.message || 'Unknown error occurred'}`);
      }
    } catch (error) {
      // Catch and log errors, and display to the user
      console.error("Error removing invitation:", error);
      toast.error(`An error occurred: ${error.message || 'Unknown error'}`);
    }
  };

  // Pagination logic
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentCampaigns = campaigns.slice(indexOfFirstUser, indexOfLastUser);

  const totalPages = Math.ceil(campaigns.length / usersPerPage); // Calculate total pages

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handleViewInvitation = (campaign) => {
    navigate('/campaigndetails', { state: { campaignDetails: campaign } });
  };

  return (
    <div className="flex flex-col h-screen">
    <div className="fixed top-0 left-0 right-0 z-40 bg-white shadow-md">
      <InfluencerHeader page="My Campaigns" />
    </div>

    <div className="flex flex-1 overflow-y-auto pt-20">
      <div className="text-white fixed top-0 left-0 bottom-0 z-50">
        <Navbar />
      </div>

      {/* Main content area */}
      <div className="ml-14 w-screen max-sm:ml-0 h-screen ">
        {/* Influencer Header */}
      

        {/* Heading for Influencers to Connect with Brands */}
        <div className="ml-12" style={{ textAlign: 'center', marginBottom: '30px', marginLeft: '20px' }}>
          <h1
            style={{
              fontSize: '17px',
              fontWeight: '700',
              color: '#000',
              textTransform: 'uppercase',
              letterSpacing: '2px',
              padding: '20px 0',
            }}
            className="text-sm sm:text-base md:text-lg lg:text-xl ml-12 mt-10"
          >
            Brand Collaboration Invitation: Be Part of Our Campaign!
          </h1>
        </div>

        {/* Message Boxes */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          {currentCampaigns.map((campaign, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                flexDirection: 'row',
                backgroundColor: '#fff',
                borderRadius: '8px',
                padding: '10px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                position: 'relative',
                alignItems: 'center',
                marginBottom: '10px',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', marginRight: '8px', position: 'relative' }}>
                <img
                  className="ml-16"
                  src={campaign.profilePic || 'https://i.postimg.cc/brqZVdrP/dummypic.jpg'}
                  alt={campaign.fullname}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                  }}
                />
                <span className="ml-6" style={{ fontSize: '16px', fontWeight: '600' }}>
                  {campaign.brandName}
                </span>
              </div>

              {/* View Invitation Button */}
              <button
  className="bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 ml-8 text-white"
  style={{
    position: 'absolute',
    top: '10px',
    right: '10px',
  }}
  onClick={() => handleViewInvitation(campaign)}
>
  View
</button>


              {/* MUI Delete Icon Button */}
              <IconButton
                onClick={() => handleRemoveInvitation(campaign._id)}
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '80px',
                }}
              >
                <DeleteIcon style={{ color: 'red' }} />
              </IconButton>
            </div>
          ))}
        </div>

        {/* Pagination Controls (only show if more than 7 invitations) */}
        {campaigns.length > usersPerPage && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <button
              onClick={prevPage}
              style={{
                padding: '10px 20px',
                backgroundColor: '#007BFF',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginRight: '10px',
              }}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            {/* Page Numbers */}
            {pageNumbers.map((number) => (
              <button
                key={number}
                onClick={() => goToPage(number)}
                style={{
                  padding: '10px 20px',
                  backgroundColor: currentPage === number ? '#0056b3' : '#007BFF',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  margin: '0 5px',
                }}
              >
                {number}
              </button>
            ))}

            <button
              onClick={nextPage}
              style={{
                padding: '10px 20px',
                backgroundColor: '#007BFF',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginLeft: '10px',
              }}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}

        {/* No Campaigns Found Message */}
        {campaigns.length === 0 && (
          <div style={{ textAlign: 'center', marginTop: '30px', fontSize: '18px', color: '#555' }}>
            <p>No invitations found</p>
          </div>
        )}
      </div>

      <ToastContainer />
    </div>
    </div>
  );
};

export default MessageBox;
